export const OGAMilestoneTableHeader = [
  {
    field: 'name',
    headerName: 'OGA',
    width: 180,
  },
  { field: 'stage', headerName: 'Current Stage', width: 180 },
  { field: 'currentMonthCollection', headerName: 'Current Month Collection', width: 220 },
  { field: 'totalCollection', headerName: 'Total Collection', width: 200 },
  { field: 'nextStage', headerName: 'Next Stage', width: 180 },
  { field: 'prevMonthCollection', headerName: 'Previous Month Collection', width: 220 },

  { field: 'performanceInsights', headerName: 'Performance Insights', width: 270 },
  { field: 'difference', headerName: 'Difference', width: 150 },
  // { field: 'collectionApril', headerName: 'Collection April 4/1/2025-6/30', width: 180 },
  // { field: 'refundApril', headerName: 'Refund April 5/1/2025-7/31', width: 180 },
  // { field: 'netCollectionApril', headerName: 'Net Collection April 7/1/2025-9/30', width: 200 },
  // { field: 'collectionMay', headerName: 'Collection May', width: 180 },
  // { field: 'refundMay', headerName: 'Refund May', width: 180 },
  // { field: 'netCollectionMay', headerName: 'Net Collection May', width: 200 },
];

export const OGAMilestoneAchievmentTable = [
  { field: 'name', headerName: 'OGA', width: 180 },
  { field: 'milestone', headerName: 'MILESTONE', width: 140 },
  { field: 'achievementDate', headerName: 'ACHIEVEMENT DATE', width: 180 },
  { field: 'eligibleDate', headerName: 'ELIGIBLE DATE', width: 180 },
];
